export enum ConversationStatus {
    Open = "OPEN",
    Assigned = "ASSIGNED",
    Unassigned = "UNASSIGNED"
}
